var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11396_138572)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8929 8.31836H7.10714C6.77132 8.31836 6.5 8.58968 6.5 8.9255V21.0684C6.5 21.4042 6.77132 21.6755 7.10714 21.6755H22.8929C23.2287 21.6755 23.5 21.4042 23.5 21.0684V8.9255C23.5 8.58968 23.2287 8.31836 22.8929 8.31836ZM22.1339 10.4206V20.3094H7.86607V10.4206L7.34241 10.0127L8.08806 9.05452L8.90011 9.68633H21.1018L21.9138 9.05452L22.6595 10.0127L22.1339 10.4206ZM21.1018 9.68443L15 14.4277L8.89821 9.68443L8.08616 9.05262L7.34051 10.0108L7.86417 10.4187L14.3454 15.458C14.5318 15.6028 14.7611 15.6814 14.9972 15.6814C15.2332 15.6814 15.4625 15.6028 15.6489 15.458L22.1339 10.4206L22.6576 10.0127L21.9119 9.05452L21.1018 9.68443Z",
    fill: "#414141"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11396_138572"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(6.5 6.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.3fe03c3ad25da332e44ccd611ceb4a05.svg";
export { ForwardRef as ReactComponent };